import "./App.css";

function App() {
  return (
    <div className="App">
      <img src="./images/content.png" alt="" className="logo" />
    </div>
  );
}

export default App;
